import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);

    return authService.initialized$.pipe(
        filter(initialized => initialized === true),
        take(1),
        switchMap(() =>
            authService.isAuthenticated$.pipe(
                take(1),
                map(isAuthenticated => {
                    if (isAuthenticated) {
                        return true;
                    }
                    // remember attempted URL for post-login redirect
                    authService.setPostLoginRedirect(state.url);
                    authService.login();
                    return false;
                })
            )
        )
    );
};

export const roleGuard = (requiredRoles: string[]): CanActivateFn => {
    return () => {
        const authService = inject(AuthService);
        const router = inject(Router);

        return authService.isAuthenticated$.pipe(
            take(1),
            map(isAuthenticated => {
                if (!isAuthenticated) {
                    authService.login();
                    return false;
                }

                if (authService.hasAnyRole(requiredRoles)) {
                    return true;
                } else {
                    // Redirect to unauthorized page or home
                    router.navigate(['/unauthorized']);
                    return false;
                }
            })
        );
    };
};
